import React from 'react';
import { Box, CardActions, TextField } from '@material-ui/core';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import {
  styles, Button, Form, theme,
} from './styles';

const ConfirmModal = (props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const {
    openDialog,
    handleReject,
    onCloseDialog,
    onChangeInput,
  } = props;
  return (
    <Form maxWidth="sm" open={openDialog} onClose={onCloseDialog}>
      <Box
        component="form"
        onSubmit={(event) => {
          handleReject(event);
          onCloseDialog();
        }}
      >
        <CardBody>
          <ThemeProvider theme={theme}>
            <TextField
              onChange={(event) => onChangeInput(event)}
              required
              fullWidth
              label="Motivo de rechazo"
              variant="outlined"
              multiline
              minRows={6}
            />
          </ThemeProvider>
        </CardBody>
        <CardActions className={classes.cardAction}>
          <Button type="button" onClick={onCloseDialog}>
            Cancelar
          </Button>
          <Button type="submit">Aceptar</Button>
        </CardActions>
      </Box>
    </Form>
  );
};

export default ConfirmModal;
